import { ActionType } from "../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { ModelPortfolioTabType } from "../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";

import { ModelPortfolio } from "../../../../Wrap/Models/Models/Instruments/ModelPortfolio";
import { InstrumentSelection } from "../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelection";
import { Weighting } from "../../../../Wrap/Models/Models/InstrumentSelection/Weighting";
import { SelectedInvestmentDispatcher } from "./Variable";

export interface SelectedInvestmentStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any[];
    isUnderTransfer?: boolean;
}

export interface AllocationTableItem extends InstrumentSelection {
    allocation: number;
    underlying?: ModelPortfolio;
    modelPortfolioType?: ModelPortfolioTabType;
    needToggle?: boolean;
    isToggle?: boolean;
    isPortfolio?: boolean;
    PostTransfer?: Weighting;
    isTargetAllocation?: boolean;
    ExistingFund?: number;
}

export class SelectedInvestmentStoreStatic extends BaseStore<SelectedInvestmentStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(SelectedInvestmentDispatcher, (actionData) =>
            this.onSelectedInvestmentStoreResponse(actionData)
        );
    }

    public getLastResult(): SelectedInvestmentStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getIsUnderTransfer() {
        return this.getState().isUnderTransfer;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): SelectedInvestmentStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
            isUnderTransfer: false,
        };
    }

    private onSelectedInvestmentStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Replace:
                this.setState({ actionType: ActionType.Replace, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, isUnderTransfer: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
